import { FC } from 'react';
import {
  AudienceLiftContainer,
  AudienceLiftTitle,
  LightColorToolTip,
  PrimaryNumber,
  PrimaryText,
  PrimaryWrapper,
  SecondaryText,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift.styles';
import {
  BREAKDOWN_AUDIENCE_SIZE_HEADER,
  BREAKDOWN_AUDIENCE_SIZE_OPTIMIZED_USERS_TOOLTIP,
  BREAKDOWN_AUDIENCE_SIZE_OPTIMIZED_USERS,
  createBreakdownAudienceSummary,
} from 'modules/intelligentInsights/constants';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { getOptimizedAudienceSize } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/breakdownUtils';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';

export const BREAKDOWN_AUDIENCE_SIZE_TEST_ID = 'breakdown-audience-size';

export type BreakdownAudienceSizeProps = {
  messageMedium: MessageMediumTab;
};
export const BreakdownAudienceSize: FC<BreakdownAudienceSizeProps> = ({ messageMedium }) => {
  const { froInsightsData } = useFroInsightsCoreContext();
  const { optimizedUsers, percentTotal } = getOptimizedAudienceSize(froInsightsData, messageMedium);
  const summaryText = createBreakdownAudienceSummary(optimizedUsers, percentTotal);
  return (
    <AudienceLiftContainer data-test={BREAKDOWN_AUDIENCE_SIZE_TEST_ID}>
      <AudienceLiftTitle>{BREAKDOWN_AUDIENCE_SIZE_HEADER}</AudienceLiftTitle>
      <PrimaryWrapper
        flexDirection="column"
        gap="quarter"
        alignItems="start"
        justifyContent="center"
      >
        <PrimaryNumber>{optimizedUsers}</PrimaryNumber>
        <LightColorToolTip
          isUnderlined
          tooltipContent={BREAKDOWN_AUDIENCE_SIZE_OPTIMIZED_USERS_TOOLTIP}
        >
          <PrimaryText>{BREAKDOWN_AUDIENCE_SIZE_OPTIMIZED_USERS}</PrimaryText>
        </LightColorToolTip>
      </PrimaryWrapper>
      <SecondaryText>{summaryText}</SecondaryText>
    </AudienceLiftContainer>
  );
};
